import React from 'react';

const Philosophy: React.FC = () => {
  return (
    <section id="philosophy" className="py-24 md:py-40">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
          <div className="relative group">
             <div className="aspect-[4/5] bg-neutral-900 overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1200" 
                  alt="Architecture" 
                  className="w-full h-full object-cover grayscale opacity-60 group-hover:scale-105 transition-transform duration-1000"
                />
             </div>
             <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-white p-12 hidden lg:flex flex-col justify-center">
                <span className="text-black text-5xl font-syne font-black mb-2">LIMITED</span>
                <span className="text-black/50 text-xs font-bold tracking-widest uppercase">Client Engagement</span>
             </div>
          </div>

          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-6xl font-syne font-bold mb-10 tracking-tighter leading-tight">
              AUTHENTIC <br />
              <span className="text-neutral-500">RELATIONSHIPS.</span>
            </h2>
            
            <div className="space-y-8 text-lg text-neutral-400 font-light leading-relaxed">
              <p>
                We intentionally limit our roster of clients to ensure every partnership receives our full intellectual and strategic capacity. Scaling revenue requires deep immersion into your ecosystem.
              </p>
              <p>
                Layer One Management is not a mass-market consulting firm. We find the perfect businesses yearly to work with—those with the potential for transformative scale and a commitment to operational excellence.
              </p>
              <p className="text-white font-medium border-l-2 border-white pl-6 py-2 italic">
                "Proven ability to create end-to-end campaigns which don't just grow—they scale exponentially."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;